<template>
  <v-container>
    <v-row v-if="supplier">
      <v-col>
        <v-card class="pa-5">
          <v-card-text>
            <!-- Supplier Image Section -->
            <div class="text-left mb-4 ml-10">
              <v-avatar size="80px">
                <img
                  v-if="supplier.profile_image"
                  :src="
                    `http://localhost:8000/storage/${supplier.profile_image}`
                  "
                  alt="Supplier Profile"
                  class="supplier-avatar"
                />
                <img
                  v-else
                  :src="defaultImage"
                  alt="Default Profile"
                  class="supplier-avatar"
                />
              </v-avatar>
            </div>
            <!-- Supplier Details Section -->
            <v-card class="mb-4 pa-4">
              <v-card-title>Supplier Details</v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label"
                      >Supplier Name</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.name
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Supplier Code</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.supplier_code
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Credit Limit</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.credit_limit ? supplier.credit_limit : "-"
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Credit Period Days</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.credit_period_days
                        ? supplier.credit_period_days
                        : "-"
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label">Status</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.status ? supplier.status : "-"
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Company Reg No</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.company_reg_no ? supplier.company_reg_no : "-"
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Company VAT Reg No</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.company_reg_no ? supplier.company_reg_no : "-"
                    }}</v-col>
                    <v-col xs="12" md="4" class="detail-label"
                      >Company NBT Reg No</v-col
                    >
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.nbt_reg_no ? supplier.nbt_reg_no : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>

            <!-- Contact Person Section -->
            <v-card class="mb-4 pa-4">
              <v-card-title>Contact Person</v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Full Name</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.contact_person ? supplier.contact_person : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Email</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.email ? supplier.email : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Mobile</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.mobile ? supplier.mobile : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Phone</v-col>
                    <v-col xs="12" md="8" class="detail-value">{{
                      supplier.phone ? supplier.phone : "-"
                    }}</v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>

            <!-- Address Details Section -->
            <v-card class="pa-4">
              <v-card-title>Address Details</v-card-title>
              <v-divider></v-divider>
              <v-list dense>
                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Country</v-col>
                    <v-col xs="12" md="8" class="detail-value">
                      {{
                        supplier.country && supplier.country.country_name
                          ? supplier.country.country_name
                          : "-"
                      }}
                    </v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">City</v-col>
                    <v-col xs="12" md="8" class="detail-value">
                      {{ supplier.city ? supplier.city : "-" }}
                    </v-col>
                  </v-row>
                </v-list-item>

                <v-list-item>
                  <v-row>
                    <v-col xs="12" md="4" class="detail-label">Address</v-col>
                    <v-col xs="12" md="8" class="detail-value">
                      {{ supplier.address ? supplier.address : "-" }}
                    </v-col>
                  </v-row>
                </v-list-item>
              </v-list>
            </v-card>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else>
      <v-col>
        <v-alert type="info">No supplier information available.</v-alert>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { filters } from "../../utility/filters";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import { SupplierService } from "@/services/supplier-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "SupplierInfo",
  data() {
    return {
      supplier: {},
      loading: false,
      defaultImage: require("@/assets/img/avatar.svg"),
    };
  },

  computed: {
    ...mapGetters({
      profile: "profile",
    }),
  },

  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.geSupplierInfo();
  },

  methods: {
    geSupplierInfo() {
      this.loading = true;
      SupplierService.getSupplierInfo(this.$route.params.uuid)
        .then((response) => {
          this.loading = false;
          if (response.data) {
            this.supplier = response.data;
            console.log(this.supplier);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.supplier = {};
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
          console.log("Error Ovccured");
        });
    },

    getProfileColor(letter) {
      return filters.getProfileColor(letter);
    },
  },
};
</script>
<style>
.profile-avatar {
  text-align: center;
  padding: 5px;
}

.profile-avatar .v-card__title {
  align-items: center;
  display: grid;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}

.icon-box {
  border-radius: 30%;
}
.detail-label {
  font-weight: 500;
  color: black;
}
.detail-value {
  color: #555;
  font-weight: 400;
}
</style>
